
import { find } from "../utils/dom.js"
import scrollGsapImg from "../modules/scrollGsapImg";

export default function comingsoon () {
	const comingsoon = find("[js-page='comingsoon']");
	if (!comingsoon) return

	document.addEventListener("DOMContentLoaded", () => {
		const dateCronometro = document.querySelector('#js-lancamento');
		const dataH = dateCronometro.getAttribute('data-lancamento');
		const [ data, hora ] = dataH.split(' ');
		const targetDate = new Date(`${data}T${hora}`);
		const countdownElements = {
			days: document.querySelector(".countdown-element.days"),
			hours: document.querySelector(".countdown-element.hours"),
			minutes: document.querySelector(".countdown-element.minutes"),
		};
	
		function updateCountdown() {
			const now = new Date();
			const timeDifference = targetDate - now;
	
			if (timeDifference <= 0) {
				countdownElements.days.textContent = "00";
				countdownElements.hours.textContent = "00";
				countdownElements.minutes.textContent = "00";
				clearInterval(interval);
				return;
			}
	
			const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
			const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
	
			animateUpdate(countdownElements.days, days);
			animateUpdate(countdownElements.hours, hours);
			animateUpdate(countdownElements.minutes, minutes);
		}
	
		function animateUpdate(element, newValue) {
			const currentValue = element.textContent;
			if (currentValue !== newValue.toString().padStart(2, "0")) {
				element.classList.add("animate");
				setTimeout(() => {
					element.textContent = newValue.toString().padStart(2, "0");
					element.classList.remove("animate");
				}, 300);
			}
		}
	
		updateCountdown();
		const interval = setInterval(updateCountdown, 1000);
	});
	
	scrollGsapImg();
	
	console.log('Page Coming Soon');
}